import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'client/hooks/useAppSelector';

const PrivateRoute: React.FC<{
  component: React.ComponentType;
}> = ({ component: Component }) => {
  const isLoggedIn = useAppSelector(({ auth: { isLoggedIn } }) => isLoggedIn);

  if (!isLoggedIn) return <Navigate to="/login" replace />;

  return <Component />;
};

export default PrivateRoute;
